var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.664 1.535a.71.71 0 0 0-.693-.033l-4.682 2.344V2.14A2.14 2.14 0 0 0 12.176 0H2.14A2.14 2.14 0 0 0 0 2.14v8.578a2.14 2.14 0 0 0 2.14 2.14h10.003a2.146 2.146 0 0 0 2.146-2.14v-1.7l4.676 2.338a.721.721 0 0 0 .963-.319c.05-.1.075-.212.072-.325V2.14a.693.693 0 0 0-.336-.605Z",
    fill: "#6F6F6F"
  })));
};
export default SvgVideo;